<template>
  <div
    class="flex flex-col space-y-6 px-4 sm:flex-row sm:space-y-0 sm:space-x-6 sm:px-0"
  >
    <i v-html="$icons.check_circle" class="text-ontick-green-600"></i>
    <div class="space-y-12">
      <div class="space-y-4">
        <h2 class="text-2xl font-bold sm:text-4xl">
          Transação realizada com sucesso!
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Você já pode começar a usar os benefícios
          {{ productByType.subtitleVariation }}
          <span class="text-ontick-carbon-900 font-bold dark:text-gray-300">{{
            productByType.subtitleName
          }}</span
          >. Bons investimentos!
        </p>
      </div>
      <div class="space-y-6">
        <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <p class="whitespace-nowrap text-lg font-bold sm:text-2xl">
              {{ productByType.infoType }}
              <span v-if="transactionData.transaction_type === 'EXTENSION'">
                {{ transactionData.extension_name }}
              </span>
            </p>
            <ontick-plan-logo-component
              :plan="transactionData.extension_name.split(' ')[0]"
              v-if="transactionData.transaction_type === 'PLAN'"
            />
          </div>
          <div class="bg-ontick-steel-500 h-[2px] w-full"></div>
        </div>
        <div class="flex flex-col space-y-4">
          <dl>
            <dt>ID da transação</dt>
            <dd>#{{ transactionData.transaction_id }}</dd>
          </dl>
          <dl>
            <dt>Desenvolvedor</dt>
            <dd>
              {{ transactionData.product_owner }}
            </dd>
          </dl>
          <dl>
            <dt>Preço</dt>
            <dd>
              {{ transactionData.transaction_value | currency }}
            </dd>
          </dl>
          <dl>
            <dt>Recorrência</dt>
            <dd>
              {{ transactionData.extension_days === 30 ? "Mensal" : "Anual" }}
            </dd>
          </dl>
        </div>
      </div>
      <router-link to="/" class="block" v-if="transactionData.last_access_date">
        <ontick-button> Ir para a plataforma </ontick-button>
      </router-link>
      <router-link
        :to="{ name: 'Auth', query: { mode: 'create_password' } }"
        class="block"
        v-else
      >
        <ontick-button> Criar senha </ontick-button>
      </router-link>
      <!-- comment -->
    </div>
  </div>
</template>

<script>
import ontickPlanLogoComponent from "../../../../shared/components/basic/ontick-plan-logo.component.vue";

export default {
  components: {
    ontickPlanLogoComponent,
  },

  props: {
    transactionData: {
      type: Object,
    },
  },

  computed: {
    productByType() {
      const types = {
        // PLAN: {
        //   subtitleVariation: `do seu plano`,
        //   subtitleName: `OnTick ${
        //     this.transactionData.name.charAt(0).toUpperCase() +
        //     this.transactionData.name.slice(1).toLowerCase().split(" ")[0]
        //   }`,
        //   infoType: "Plano OnTick",
        // },
        EXTENSION: {
          subtitleVariation: "da sua extensão",
          subtitleName: this.transactionData.extension_name,
          infoType: "Extensão",
        },
      };
      return types[this.transactionData.transaction_type];
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  dt {
    @apply text-sm;
  }
  dd {
    @apply text-ontick-carbon-900  text-xl font-bold dark:text-gray-300;
  }
}
</style>
